import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=fc66f08e&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/vagrant/git/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fc66f08e')) {
      api.createRecord('fc66f08e', component.options)
    } else {
      api.reload('fc66f08e', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=fc66f08e&", function () {
      api.rerender('fc66f08e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/suggestion/components/detail.vue"
export default component.exports